module.exports = __webpack_public_path__ + "9cff922cac1f503aec173117ddf7135b.svg";